export default __webpack_public_path__ + "maps-examples-user-location-annotation-960-d7fcba8fb9df7e9aac7ceb23fd3195da.png";